/** @namespace Bodypwa/Component/ScrollSwiper/Config */

export const SCROLL_EPS = 1;
export const DRAG_SCROLL_MULTIPLIER = 3;
export const AUTOPLAY_SCROLL_STEP = 15;
export const AUTOPLAY_INTERVAL_MS = 100;
export const SCROLL_DEBOUNCE_MS = 200;
export const MASK_GRADIENT_STOP = '95%';
